import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import FormModal from "@@/core/libraries/form/FormModal";
import {BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, VBToggle} from "bootstrap-vue";

export default {
  name: "SellTypes",
  components: {
    FormModal,
    Loading,
    BTooltip, BButton, BCard, BTable, BCollapse, BFormGroup, BFormInput
  },
  directives: {
    'b-toggle': VBToggle,
  },
  mixins: [mixins],
  data() {
    return {
      stores:[],
      createRules:[],
      editRules:[],
      selectedStores: [],
      url: 'admin/sell-types',
      fields: [{
        key: 'index',
        label: 'ردیف'
      },
        {
          key: 'title',
          label: 'عنوان انگلیسی'
        },
        {
          key: 'label',
          label: 'عنوان فارسی'
        },
        {
          key: 'created_at',
          label: 'تاریخ ثبت'
        },
        {
          key: 'stores',
          label: 'انبار ها'
        },
        {
          key: 'edit',
          label: 'ویرایش'
        },
        {
          key: 'delete',
          label: 'حذف'
        },
      ],
      filter: {
      },
      status_options: [{
        name: 'فعال',
        value: '1'
      },
        {
          name: 'غیرفعال',
          value: '0'
        },
        {
          name: 'همه',
          value: ''
        },
      ],
    }
  },
  mounted() {
    this.loadSellTypes();
    this.loadStores();
  },
  watch: {  
      selectedStores: {  
          handler(newVal) {  
              console.log('selectedStores changed:', newVal);  
          },  
          deep: true,  
      }  
  },  
  methods: {
    selectStore(store, itemId) {  
        if (!this.selectedStores[itemId]) {  
            this.$set(this.selectedStores, itemId, []);  
        }  
        const index = this.selectedStores[itemId].findIndex(selectedStore => selectedStore.id === store.id);  
        if (index > -1) {  
            this.selectedStores[itemId].splice(index, 1);  
        } else {  
            this.selectedStores[itemId].push(store);  
        }  
    },
    isSelected(store, itemId) {  
        return this.selectedStores[itemId] && this.selectedStores[itemId].some(selectedStore => selectedStore.id === store.id);  
    },
    async submitSortStores(id) {
        let formattedStores = [];
    
        if (this.selectedStores[id]) {
            this.selectedStores[id].forEach((store, index) => {
                formattedStores.push({
                    store_id: store.id,
                    priority: index + 1
                });
            });
        }
        const data = {
            stores: formattedStores,
        };
    
        try {
            const response = await this.$axios.put(`admin/sell-types/${id}/assign-store`, data);
            this.$root.notify(response.data.message, "success");
            const modalId = `#sort-stores-${id}`;  
            $(modalId).modal('hide');  
        } catch (e) {
            this.$root.notify(e);
        }
    },
    async loadSellTypes(){
      try {
        const response = await this.$axios.get("admin/sell-types");
        this.items = response.data.data.sellTypes;
        this.createRules = response.data.data.store_rules;
        this.editRules = response.data.data.update_rules;
        this.items.forEach(item => {  
          if (!this.selectedStores[item.id]) {  
              this.$set(this.selectedStores, item.id, []);
          }  
          item.stores.forEach(store => {  
              if (!this.selectedStores[item.id].some(selectedStore => selectedStore.id === store.id)) {  
                  this.selectedStores[item.id].push(store);  
              }  
          });  
      });
      } catch (e) {
        this.$root.notify(e);
      }
    },
    async loadStores(){
      try {
        const response = await this.$axios.get("admin/stores");
        this.stores = response.data.data.stores;
      } catch (e) {
        this.$root.notify(e);
      } 
    },
    deleteItem(id) {
      window.swal({
          title: "آیتم حذف شود؟",
          text: "این عملیات غیر قابل بازگشت خواهد بود",
          icon: "warning",
  
          showCancelButton: true,
          showConfirmButton: true,
          dangerMode: true,
          buttons: ["خیر", "بله حذف کن"]
      })
      .then((willDelete) => {
          if (willDelete) {
          this.$axios.delete(`admin/sell-types/${id}`)
              .then((response) => {
                  this.items = this.items.filter(item => item.id != id)
                  window.swal({
                  icon: "success",
                  showConfirmButton: true,
                  text: response.data.message,
                  button: "باشه",
                  })
              })
              .catch(error => {
                  window.swal({
                  title: 'خطا',
                  showConfirmButton: true,
                  text: error.response.data.message,
                  button: "باشه",
                  })
              })
          }
      })
      .catch(() => {
      })
    },
    editItem(index) {
        if (!(this.edit && this.edit._index === index) || this.mode !== 'edit') {
            let item;
            item = window.clone(this.items[index])
            item._index = index
            this.edit = item
            this.mode = 'edit'
        }
        this.$root.$emit('bv::show::modal', 'modal-' + this.$options.name)
    },
    onCreate(data) {
        let objectKey = Object.keys(data.data)[0]
        this.items.unshift(data.data[objectKey])
    },
    onEdit(data, index) {
        let objectKey = Object.keys(data.data)[0]
        let model = data.data[objectKey];
        this.$root.$set(this.items, index, model);
    },
  }
}
